var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import rawColors from "../rawColors";
var appColors = {
    primary: rawColors.green.netdata,
    accent: rawColors.green.chateau,
    main: rawColors.neutral.limedSpruce,
    border: rawColors.neutral.regentgrey,
    borderSecondary: rawColors.neutral.porcelain,
    tabsBorder: rawColors.neutral.iron,
    disabled: rawColors.neutral.porcelain,
    disabledBackground: rawColors.neutral.porcelain,
    dropdown: rawColors.neutral.white,
    elementBackground: rawColors.neutral.blackhaze,
    elementBackgroundHover: rawColors.neutral.white,
    mainBackground: rawColors.neutral.white,
    mainBackgroundDisabled: rawColors.neutral.blackhaze,
    modalHeaderBackground: rawColors.neutral.shark,
    modalTabsBackground: rawColors.neutral.blackhaze,
    modalBackground: rawColors.neutral.white,
    modalInfoBackground: rawColors.neutral.blackhaze,
    success: rawColors.green.netdata,
    successLite: rawColors.green.deyork,
    successBackground: rawColors.green.frostee,
    warning: rawColors.yellow.amber,
    warningLite: rawColors.yellow.mustard,
    warningBackground: rawColors.yellow.ginfizz,
    warningText: rawColors.yellow.seaBuckthorn,
    error: rawColors.red.pomegranate,
    errorLite: rawColors.red.apricot,
    errorBackground: rawColors.red.lavender,
    errorText: rawColors.red.pomegranate,
    attention: rawColors.purple.mauve,
    attentionSecondary: rawColors.purple.daisy,
    separator: rawColors.neutral.bluebayoux,
    controlFocused: rawColors.neutral.limedSpruce,
    selected: rawColors.neutral.iron,
    tooltip: rawColors.neutral.shark,
    bright: rawColors.neutral.white,
    text: rawColors.neutral.limedSpruce,
    textLite: rawColors.neutral.regentgrey,
    textFocus: rawColors.neutral.regentgrey,
    textDescription: rawColors.neutral.bluebayoux,
    sectionHeaderBackground: rawColors.neutral.limedSpruce,
    sectionTitle: rawColors.neutral.bluebayoux,
    sectionDescription: rawColors.neutral.regentgrey,
    menuItem: rawColors.neutral.iron,
    placeholder: rawColors.neutral.iron,
    key: rawColors.neutral.regentgrey,
    panel: rawColors.neutral.limedSpruce,
    nodesViewMiniCharts: rawColors.neutral.iron,
    //Input colors
    inputBorder: rawColors.neutral.iron,
    inputBorderHover: rawColors.neutral.regentgrey,
    inputBorderFocus: rawColors.neutral.bluebayoux,
    // Badges
    nodeBadgeBackground: rawColors.neutral.porcelain,
    nodeBadgeBorder: rawColors.neutral.iron,
    nodeBadgeColor: rawColors.neutral.bluebayoux,
};
export default __assign(__assign({}, appColors), rawColors);
